import { TextField } from '@mui/material';
import AdapterJalali from '@date-io/date-fns-jalali';
import dayjs from 'dayjs';
import {
  MobileTimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers-pro';
import React from 'react';
import { TimeToMinutes } from 'utils/TimeToMinutes';
import { ConvertDateObjectToTimeFormat } from 'utils/ConvertDateObjectToTimeFormat';
import RightAlignedTextField from 'Global/Components/CommonComponents/RightAlignedTextField/RightAlignedTextField';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
const EditableSingularTimePicker = ({
  label,
  onChange,
  errors,
  name,
  getter,
  isDateTime = false,
  isEnglish = true,
  OutputInMinutes = false,
  initalValue = false,
  fullWidth = false,
}) => {
  let timeParts = initalValue
    ? initalValue.split(':')
    : null;
  let date = new Date();
  timeParts &&
    date.setHours(timeParts[0], timeParts[1], 0, 0);

  const [value, setValue] = React.useState(
    date ? dayjs(new Date(date)) : dayjs(new Date())
  );
  React.useEffect(() => {
    if (initalValue) {
      let timeParts = initalValue.split(':');
      let date = new Date();
      date.setHours(timeParts[0], timeParts[1], 0, 0);
      setValue(dayjs(date));
    }
  }, [initalValue]);

  const done_msg = FindLangKey(
    'general-public-label-approve'
  );
  const cancel_msg = FindLangKey(
    'general-public-label-dismiss'
  );
  return (
    <LocalizationProvider
      dateAdapter={AdapterJalali}
      localeText={{
        okButtonLabel: done_msg,
        cancelButtonLabel: cancel_msg,
      }}
    >
      <div
        dir={isEnglish ? 'ltr' : 'rtl'}
        style={{
          width: fullWidth ? '100%' : '',
        }}
      >
        <MobileTimePicker
          label={label}
          ampm={false}
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
            !isDateTime &&
              onChange &&
              onChange(
                OutputInMinutes
                  ? TimeToMinutes(
                      ConvertDateObjectToTimeFormat(
                        newValue
                      )
                    )
                  : ConvertDateObjectToTimeFormat(newValue)
              );

            getter &&
              getter((prev) => ({
                ...prev,
                Time: TimeToMinutes(
                  ConvertDateObjectToTimeFormat(newValue)
                ),
              }));
          }}
          renderInput={(params) =>
            !isEnglish ? (
              <RightAlignedTextField
                color="colorPrimer"
                {...params}
                fullWidth
                InputProps={{
                  style: {
                    height: '40px',
                  },
                }}
              />
            ) : (
              <TextField
                color="colorPrimer"
                {...params}
                fullWidth
                InputProps={{
                  style: {
                    height: '40px',
                  },
                }}
              />
            )
          }
        />
      </div>
    </LocalizationProvider>
  );
};

export default EditableSingularTimePicker;
